import DatePicker from "react-datepicker";
import { IIncident } from "../domain/IIncident";
import ProjectSelect from "Dashboard/scenes/Projects/components/ProjectSelect";
import IncidentSelect from "Dashboard/scenes/Incidents/components/IncidentTypeSelectCreate";
import { styles } from "./SelectStyle";
import { IIncidentType } from "../domain/IIncidentType";
import CancelIcon from "@mui/icons-material/Cancel";
import { IOption } from "Dashboard/domain/IOption";
import EmployeeSelect from "Dashboard/scenes/Resources/components/EmployeeSelect";
import CurrencyInput from "react-currency-input-field";
import { IIncidentUpdate } from "../domain/IIncidentUpdate";
import InfoTooltip from "components/Popup/InfoTooltip";
import { setDeleteIncidentModalOpen } from "../incident.slice";
import { useAppDispatch } from "hooks/hooks";
import { IProjectOption } from "Dashboard/domain/IProjectOption";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasFullAccessTo, hasWriteAccessTo } from "utils/authUtil";
import { INCIDENT_MODULE_NAME } from "../domain/IncidentModule";
import { useSelector } from "react-redux";

interface IProps {
  incident: IIncident;
  index: number;
  incidentTypes: IIncidentType[];
  projects: IProjectOption[];
  employees: IOption[];
  incidentTypeOptions: IOption[];
  setIncidentTypeOptions: any;
  updateIncident: (data: IIncidentUpdate) => void;
}

const TableRow = ({
  incident,
  index,
  projects,
  employees,
  incidentTypeOptions,
  setIncidentTypeOptions,
  updateIncident,
}: IProps) => {
  const dispatch = useAppDispatch();
  const { user } = useSelector(selectStateAuth);

  return (
    <div className="row row-height row-fix">
      <div className="col">
        <input type="checkbox" disabled={!hasWriteAccessTo(user, INCIDENT_MODULE_NAME)} />
        <div className="first-col">
          <InfoTooltip tooltip="Vrsta incidenta" element="span">
            <IncidentSelect
              customStyles={styles.customStyles}
              options={incidentTypeOptions}
              setIncidentTypeOptions={setIncidentTypeOptions}
              defaultValue={incident.incidentTypeId}
              onChange={(incidentTypeId: number) => {
                updateIncident({
                  incidentId: incident.incidentId,
                  incidentTypeId,
                });
              }}
              disabled={!hasWriteAccessTo(user, INCIDENT_MODULE_NAME)}
            />
          </InfoTooltip>
          <InfoTooltip tooltip="Projekat" element="span">
            <ProjectSelect
              customStyles={styles.customStylesLight}
              options={projects}
              defaultValue={incident.projectId}
              onChange={(projectId: number) => {
                updateIncident({
                  incidentId: incident.incidentId,
                  projectId,
                });
              }}
              placeholder="Projekat"
              disabled={!hasWriteAccessTo(user, INCIDENT_MODULE_NAME)}
            />
          </InfoTooltip>
        </div>

        {hasFullAccessTo(user, INCIDENT_MODULE_NAME)
          ?
          <InfoTooltip tooltip="Obriši zapis" element="span">
            <button className="btn-del" onClick={(e) => {
              e.stopPropagation();
              dispatch(setDeleteIncidentModalOpen({ visible: true, index }));
            }}>
              <CancelIcon fontSize="small" />
            </button>
          </InfoTooltip>
          : <></>}
      </div>
      <div>
        <InfoTooltip tooltip="Počinioc zaposleni" element="span">
          <EmployeeSelect
            customStyles={styles.customStyles}
            defaultValue={incident.perpetratorEmployeeId}
            options={employees}
            onChange={(perpetratorEmployeeId: number) => {
              updateIncident({
                incidentId: incident.incidentId,
                perpetratorEmployeeId,
              });
            }}
            placeholder="Počinioc zaposleni"
            disabled={!hasWriteAccessTo(user, INCIDENT_MODULE_NAME)}
          />
        </InfoTooltip>
      </div>
      <div className="col">
        <DatePicker
          className="datePicker"
          dateFormat="dd/MM/yyyy"
          showMonthDropdown
          showYearDropdown
          onChange={(date: any) => {
            updateIncident({ incidentId: incident.incidentId, date });
          }}
          selected={new Date(incident.date)}
          disabled={!hasWriteAccessTo(user, INCIDENT_MODULE_NAME)}
        />
      </div>
      <div className="col">
        <CurrencyInput
          id="input-example"
          name="input-name"
          suffix=" rsd"
          defaultValue={incident.amount}
          onValueChange={(value: string | undefined) => {
            const amount: number = value ? parseFloat(value) : 0;
            updateIncident({ incidentId: incident.incidentId, amount });
          }}
          decimalsLimit={2}
          decimalSeparator=","
          groupSeparator="."
          disabled={!hasWriteAccessTo(user, INCIDENT_MODULE_NAME)}
        />
      </div>
      <div className="col">
        <textarea
          spellCheck="false"
          className="textarea"
          defaultValue={incident?.description ?? ""}
          onChange={(e) => updateIncident({ incidentId: incident.incidentId, description: e.target.value })}
          disabled={!hasWriteAccessTo(user, INCIDENT_MODULE_NAME)}
        ></textarea>
      </div>
      <div className="col light">
        <div className="bg-item-border-light center">
          {incident.reporterEmployeeUsername}
        </div>
      </div>
    </div>
  );
};

export default TableRow;